import React from 'react'
import { Container, Card } from 'react-bootstrap'
import { capitalizeOnlyFirstLetter } from 'application/helpers'
import * as S from './proposalElements'
import * as P from './../pdf/pdfElements'
import { Emission } from '@mmsg/louie'
import CardEntry from './cardEntry'
import CarImageSection from 'application/components/pages/proposal/carImageSection'
import { IProposalCarDetailsSectionProps } from './proposalInterfaces/carDetailsSectionProps'
import globals from 'application/constants/globals'

interface ICarAttributeProps {
  title?: string | JSX.Element
  value?: string
  id: string
}

const CarDetailsSection = (props: IProposalCarDetailsSectionProps) => {
  let engineText = props.vehicle.engineSize
    ? props.vehicle.engineSize + ' '
    : ''
  engineText +=
    globals.isBrandMX && props.vehicle.fuelType ? props.vehicle.fuelType : ''

  const emissionAttribute = (
    <p>
      CO<sub>2</sub> emissions
    </p>
  )
  const cO2EmissionsPerKM = props.vehicle.cO2EmissionsPerKM

  var items: ICarAttributeProps[] = []
  items.push({ title: 'Series', value: props.vehicle.variant, id: 'series' })
  if (globals.isBrandMX) {
    items.push(
      { title: 'Engine', value: engineText, id: 'engine' },
      {
        title: 'Transmission',
        value: props.vehicle.transmission,
        id: 'transmission',
      },
      { title: 'Body', value: props.vehicle.style, id: 'body' },
      {
        title: 'Colour',
        value: props.vehicle.bodyColour,
        id: 'colour',
      },
      {
        title: 'Interior colour',
        value: props.vehicle.trimColour,
        id: 'interiorcolour',
      }
    )
  }
  if (globals.isBrandRS) {
    items.push(
      {
        title: 'Colour',
        value: props.vehicle.bodyColour,
        id: 'colour',
      },
      {
        title: 'Interior colour',
        value: props.vehicle.trimColour,
        id: 'interiorcolour',
      },
      { title: 'Engine', value: engineText, id: 'engine' },
      {
        title: 'Transmission',
        value: props.vehicle.transmission,
        id: 'transmission',
      },
      { title: 'Body', value: props.vehicle.style, id: 'body' }
    )
  }
  items.push(
    {
      title: globals.isBrandMX ? 'Fuel' : 'Fuel type',
      value: capitalizeOnlyFirstLetter(props.vehicle.fuelType),
      id: 'fuel',
    },
    {
      title: 'Cylinders',
      value: props.vehicle.vehicleCylinderConfig,
      id: 'cylinders',
    }
  )
  
  if (props.vehicle.payLoad && props.vehicle.payLoad.toString() !== '0')
    items.push({
      title: 'Payload',
      value: props.vehicle.payLoad,
      id: 'payload',
    })
  if (cO2EmissionsPerKM != null)
    items.push({
      title: emissionAttribute,
      value: cO2EmissionsPerKM + ' g/km',
      id: 'co2',
    })

  return props.pdf ? (
    <div className="card-section">
      <Container className="section mt-4" id="cardetailssection">
        <P.StyledCard>
          <P.StyledCardHeader>
            <P.StyledCardHeaderText id="cardetailssection.title">
              {props.title}
            </P.StyledCardHeaderText>
          </P.StyledCardHeader>
          <P.CarTitle>
            {props.vehicle.id && (
              <span>
                {props.vehicle.vehicleType === 'New' ? 'New' : 'Used'}{' '}
                <span id="cardetailssection.vehicleyearmake">
                  {props.vehicle.year} {props.vehicle.make}{' '}
                </span>
                <span id="cardetailssection.vehiclefamily">
                  {props.vehicle.family}
                </span>
              </span>
            )}
          </P.CarTitle>
          {props.vehicle.id && (
            <P.CarDescriptor id="cardetailssection.vehicledescription">
              {props.vehicle.vehicleDescription}
            </P.CarDescriptor>
          )}
          {!props.vehicle.id && (
            <P.CarDescriptor id="cardetailssection.vehicledescription">
              {props.vehicle.vehicleDescription}
            </P.CarDescriptor>
          )}
          <S.CarBodySection>
            <Card.Body>
              {items.map((c) => (
                <CardEntry title={c.title} value={c.value} id={c.id} boldText />
              ))}
            </Card.Body>
            <S.CarImageSection>
              <CarImageSection
                vehicle={props.vehicle}
                proposalUpdatedDate={props.proposalUpdatedDate}
                pdf={true}
              />
            </S.CarImageSection>
          </S.CarBodySection>
          {cO2EmissionsPerKM != null && (
            <S.EmissionContainerPdf>
              <Emission
                value={cO2EmissionsPerKM}
                id="cardetailssection.emission"
              />
            </S.EmissionContainerPdf>
          )}
        </P.StyledCard>
      </Container>
    </div>
  ) : (
    <div className="card-section">
      <Container className="section mt-4" id="cardetailssection">
        <Card className="mb-13rem card-shadow">
          <Card.Header className="border-bottom-0">
            <S.CardHeader id="cardetailssection.title">
              {props.title}
            </S.CardHeader>
          </Card.Header>
          <Card.Body>
            {items.map((c) => (
              <CardEntry title={c.title} value={c.value} id={c.id} boldText />
            ))}
            {cO2EmissionsPerKM != null && (
              <S.EmissionContainer>
                <Emission value={cO2EmissionsPerKM} />
              </S.EmissionContainer>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  )
}

export default CarDetailsSection
